import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { frameId: String }

  connect() {
    this.frame = document.getElementById(this.frameIdValue)
    if (!this.frame) return

    this.observer = new MutationObserver(() => this.sync())
    this.observer.observe(this.frame, { attributes: true, attributeFilter: [ "busy", "aria-busy" ] })
    this.sync()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  sync() {
    const busy = this.frame.hasAttribute("busy") || this.frame.getAttribute("aria-busy") === "true"
    this.element.classList.toggle("hidden", !busy)
  }
}
